"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDownload = isDownload;
exports.formatName = formatName;
exports.shortenName = shortenName;
exports["default"] = void 0;

var _xApiStatementFactory = _interopRequireDefault(require("../xApi/xApiStatementFactory"));

var _configOptions = require("../constants/config-options");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Format event value names to kebab case for use in IRI's.
 *
 * @param {String} name
 * @return {String} The formatted name.
 */
function formatName(name) {
  if (!name) return '';
  return name.replace(/\s+/g, '-').toLowerCase();
}
/**
 * Shorten event value and format with formatName
 * Truncates at right most hyphen and shortens on word
 *
 * @param {String} name Name to shorten.
 * @param {Number} max Max number of chars.
 * @return {String} The formatted name.
 */


function shortenName(name, max) {
  if (!name) return '';
  if (!max) max = 50;
  var formattedName = name; // Replaces en-dash and em-dash with normal hyphens.

  formattedName = formattedName.replace(/\u2013|\u2014/g, '-'); // Truncate on right most hyphen

  if (formattedName.length > max) {
    formattedName = formattedName.slice(0, formattedName.lastIndexOf('-')).trim();
  } // Shorten by word


  if (formattedName.length > max) {
    var wordBoundry = formattedName.lastIndexOf(' ');

    while (wordBoundry > max) {
      wordBoundry = formattedName.lastIndexOf(' ', wordBoundry - 1);
    }

    formattedName = formattedName.slice(0, wordBoundry);
  }

  return formatName(formattedName);
}
/**
 * Check if anchor file type is download
 *
 * @param {HTMLAnchorElement} element HTMLAnchorElement to check.
 * @return {Boolean} True if it's a download type.
 */


function isDownload(element) {
  for (var t = 0; t < _configOptions.DOWNLOAD_TYPES.length; t++) {
    // Checks for <a href="..." type="application/XXX">
    if (element.type.endsWith("/".concat(_configOptions.DOWNLOAD_TYPES[t]))) {
      return true;
    } // Checks for <a href="something.XXX">


    if (element.href.endsWith(".".concat(_configOptions.DOWNLOAD_TYPES[t]))) {
      return true;
    }
  } // Anything from Google drive is a download


  if (element.href.startsWith('https://drive.google.com')) {
    return true;
  }

  return false;
}

var EventService = /*#__PURE__*/function () {
  /**
   * Initialize the service by setting up an event factory with configuration.
   *
   * @param {Object} config
   */
  function EventService(config) {
    _classCallCheck(this, EventService);

    this.eventFactory = new _xApiStatementFactory["default"](config, config[_configOptions.CONFIG_OPTIONS.ENVIRONMENT]);
    this.stashedEventsKey = "stashedEvents-".concat(formatName(config[_configOptions.CONFIG_OPTIONS.APP_NAME]), "-") + "".concat(config[_configOptions.CONFIG_OPTIONS.USER_ID]);
    this.config = config;
    this.language = config[_configOptions.CONFIG_OPTIONS.LANGUAGE];
    this.homePage = config[_configOptions.CONFIG_OPTIONS.HOMEPAGE];
    this.sendEventsImmediately = config[_configOptions.CONFIG_OPTIONS.SEND_EVENTS_IMMEDIATELY];

    if (config[_configOptions.CONFIG_OPTIONS.APP_NAME] && config[_configOptions.CONFIG_OPTIONS.USER_ID]) {
      // Send any stashed events.
      this.sendStashedEvents();
    }
  }
  /**
   * Set the display language.
   *
   * @param {String} language
   */


  _createClass(EventService, [{
    key: "setLanguage",
    value: function setLanguage(language) {
      this.language = language;
      this.eventFactory.setLanguage(language);
    }
    /**
     * Set the homepage.
     *
     * @param {String} homePage
     */

  }, {
    key: "setHomePage",
    value: function setHomePage(homePage) {
      this.homePage = homePage;
      this.eventFactory.setHomePage(homePage);
    }
    /**
     * Create a new xAPI event and add basic actor data.
     *
     * @return {Object} The event.
     */

  }, {
    key: "createEvent",
    value: function createEvent() {
      return this.eventFactory.create().addActorAccount('name', this.config[_configOptions.CONFIG_OPTIONS.USER_ID]).addActorAccount('homePage', this.homePage);
    }
    /**
     * Add verb data to an event, representing the action being done. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} name The verb name.
     */

  }, {
    key: "addVerb",
    value: function addVerb(event, name) {
      event.addVerbId(name).addVerb('display', _defineProperty({}, this.language, name));
    }
    /**
     * Add object data to an event. Transforms the passed in event.
     * If this is a DOM element, the elementType can be used to set the page-element-type object extension.
     *
     * @param {Object} event
     * @param {String} objectId The id or name of the object being acted on.
     * @param {String?} elementType (Optional) The type of DOM element being acted on.
     * @param {Boolean?} addDefinition (Optional) Whether a definition should be added to the event.
     */

  }, {
    key: "addObject",
    value: function addObject(event, objectId, elementType) {
      var addDefinition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      event.addObjectId(objectId).addObject('objectType', 'Activity');

      if (addDefinition) {
        event.addObjectDefinition('name', objectId);
      }

      if (elementType) {
        event.addObjectExtension('page-element-type', elementType);
      }
    }
    /**
     * Add context data to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} key
     * @param {String} value
     */

  }, {
    key: "addContext",
    value: function addContext(event, key, value) {
      event.addContext(key, value);
    }
    /**
     * Add context extension data to an event when there is useful additional context to log. Transforms the passed
     * in event.
     *
     * @param {Object} event
     * @param {Object} extensions
     */

  }, {
    key: "addContextExtensions",
    value: function addContextExtensions(event, extensions) {
      Object.entries(extensions).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        event.addContextExtension(key, value);
      });
    }
    /**
     * Add result data to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {String} key
     * @param {String} value
     */

  }, {
    key: "addResult",
    value: function addResult(event, key, value) {
      event.addResult(key, value);
    }
    /**
     * Add result extensions to an event. Transforms the passed in event.
     *
     * @param {Object} event
     * @param {Object} extensions
     */

  }, {
    key: "addResultExtensions",
    value: function addResultExtensions(event, extensions) {
      Object.entries(extensions).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        event.addResultExtension(key, value);
      });
    }
    /**
     * Stash event in localStorage, to be sent when app is next loaded. Used for events captured on leaving the app.
     * Can only be used on the client side.
     *
     * @param {Object} event
     */

  }, {
    key: "stashEvent",
    value: function stashEvent(event) {
      if (typeof window === 'undefined') return;
      event.setTimestamp(new Date().toISOString());
      var stashedEvents = localStorage.getItem(this.stashedEventsKey);

      try {
        stashedEvents = stashedEvents ? JSON.parse(stashedEvents) : [];
        localStorage.setItem(this.stashedEventsKey, JSON.stringify(stashedEvents.concat([event])));

        if (this.sendEventsImmediately) {
          this.sendStashedEvents();
        }
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * Send any events that have been stashed in localStorage.
     * Can only be used on the client side.
     *
     * @return {Promise}
     */

  }, {
    key: "sendStashedEvents",
    value: function sendStashedEvents() {
      var _this = this;

      if (typeof window === 'undefined') return;
      var stashedEvents = localStorage.getItem(this.stashedEventsKey);
      var promises = [];

      if (stashedEvents) {
        try {
          JSON.parse(stashedEvents).forEach(function (stashedEvent) {
            var event = _this.createEvent();

            event.statement = Object.assign(event.statement, stashedEvent.statement);
            promises.push(event.emit());
          });
        } catch (error) {
          console.error(error);
        }

        localStorage.removeItem(this.stashedEventsKey);
      }

      return Promise.all(promises);
    }
    /**
     * Send an xAPI event when an app is loaded.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     *
     * @return {Promise}
     */

  }, {
    key: "sendAppLoadedEvent",
    value: function sendAppLoadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'loaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      return event.emit();
    }
    /**
     * Send an xAPI event when the app is unloaded.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     *
     * @return {Promise}
     */

  }, {
    key: "sendAppUnloadedEvent",
    value: function sendAppUnloadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      return event.emit();
    }
    /**
     * Stash an xAPI event when the app is unloaded.
     * Should only be used on the client side.
     *
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     */

  }, {
    key: "stashAppUnloadedEvent",
    value: function stashAppUnloadedEvent(contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'unloaded');
      this.addObject(event, this.config[_configOptions.CONFIG_OPTIONS.APP_NAME]);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      this.stashEvent(event);
    }
    /**
     * Send an xAPI event when a page is opened.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     * @return {Promise}
     */

  }, {
    key: "sendPageOpenedEvent",
    value: function sendPageOpenedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'opened');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      return event.emit();
    }
    /**
    * Send an xAPI event when a page is opened.
    *
    * @param {String} pageName The page name (typically the <title> elsment value).
    * @param {String} pagePath The page name or path.
    * @param {Object?} contextExtensions Optional data representing the context for the event.
    * @param {Object?} resultExtensions Optional data representing the result for the event.
    * @return {Promise}
    */

  }, {
    key: "sendPageViewedEvent",
    value: function sendPageViewedEvent(pageName, pagePath, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'viewed');
      this.addObject(event, shortenName(pageName, 25));
      event.addObjectDefinition('location', pagePath);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      return event.emit();
    }
    /**
     * Send an xAPI event when a page is closed.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     * @return {Promise}
     */

  }, {
    key: "sendPageClosedEvent",
    value: function sendPageClosedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      return event.emit();
    }
    /**
     * Stash an xAPI event when a page is closed.
     * Should only be used on the client side.
     *
     * @param {String} page The page name or path.
     * @param {Object?} contextExtensions Optiional data representing the context for the event.
     * @param {Object?} resultExtensions Optional data representing the result for the event.
     */

  }, {
    key: "stashPageClosedEvent",
    value: function stashPageClosedEvent(page, contextExtensions, resultExtensions) {
      var event = this.createEvent();
      this.addVerb(event, 'closed');
      this.addObject(event, 'webpage');
      event.addObjectDefinition('location', page);

      if (contextExtensions) {
        this.addContextExtensions(event, contextExtensions);
      }

      if (resultExtensions) {
        this.addResultExtensions(event, resultExtensions);
      }

      this.stashEvent(event);
    }
  }]);

  return EventService;
}();

exports["default"] = EventService;